const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const esEmailValido = (email) => emailRegex.test(email);
